import React from 'react';
import animateScrollTo from 'animated-scroll-to';
import { HEADER_HEIGHT, MOBILE_WIDTH } from '../../constants/dims';
import styled from 'styled-components/macro';

const ArrowDown = styled.div`
  position: absolute;
  bottom: 24px;
  width: 100%;
  text-align: center;
  cursor: pointer;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    display: none;
    position: relative;
    bottom: 0px;
    padding-bottom: 12px;
  }
`;

const ScrollTo = ({ selector }) => {
  return (
    <ArrowDown
      onClick={() =>
        animateScrollTo(document.querySelector(selector), {
          verticalOffset:
            window.innerWidth >= MOBILE_WIDTH ? -HEADER_HEIGHT : 0,
        })
      }
    >
      <i className="fas fa-chevron-down fa-2x"></i>
    </ArrowDown>
  );
};

export default ScrollTo;
